<template>
  <section>
 <div id="invoice-POS" style="font-family: Helvetica, sans-serif;">
    
    <center >
		<div> 
			<p>
			<b>{{this.selectedTableOrder.branchesByBranchId.restaurantsByRestaurantId.name}}</b><br>
			{{this.selectedTableOrder.branchesByBranchId.areasByAreaId.name}}<br>
			Tel:{{this.selectedTableOrder.branchesByBranchId.phone1}}</p>
		</div>
    </center>
	<hr style="border: 1px solid black">
	<table width="100%" style="text-align:left; font-size:13px;">
		<tr>
			<td>Cashier: {{this.selectedTableOrder.usersByUserId.fullName}}</td>
			<td>Branch Id: {{this.selectedTableOrder.branchesByBranchId.id}}</td>
		</tr>
		<tr>
			<td>Order Id: {{this.selectedTableOrder.id>0 ? this.selectedTableOrder.id : ''}}</td>
			<td>NTN: {{this.selectedTableOrder.branchesByBranchId.restaurantsByRestaurantId.ntn}}</td>
		</tr>
		<tr>
			<td>Table: {{this.selectedTableOrder.table.name}}</td>
			<td>Date: {{this.$moment.parseZone(String(new Date())).local().format('DD-MM-YYYY hh:mm:ss A')}}</td>
		</tr>
	</table>
	<!-- <center><p>{{this.$moment.parseZone(String(new Date())).local().format('DD-MM-YYYY hh:mm:ss A')}}</p></center> -->
	<center><h2>{{this.selectedTableOrder.orderTypesByOrderTypeId.type}}</h2></center>
	<table style=" border: 1px solid black;border-collapse: collapse;" width="100%">
	<tr>
		<th style="width:5%; border: 1px solid black;border-collapse: collapse;font-size:13px;">Sr.</th>
		<th style="width:50%; border: 1px solid black;border-collapse: collapse; text-align:left;font-size:13px;">Item Name</th>
		<th style="width:15%; border: 1px solid black;border-collapse: collapse;font-size:13px;">Rate</th>
		<th style="width:15%; border: 1px solid black;border-collapse: collapse;font-size:13px;">Qty</th>
		<th style="width:15%; border: 1px solid black;border-collapse: collapse;font-size:13px;">Total</th>
	</tr>
	<template v-for="(orderItem, orderItemIndex) in this.selectedTableOrder.orderItemsById">
		<tr v-bind:key="orderItemIndex">
			<td style="width:5%;font-size:13px;border: 1px solid black;border-collapse: collapse; border-bottom:none !important">{{orderItemIndex +1}}</td>
			<td style="width:50%;text-align:left; font-size:14px;border: 1px solid black;border-collapse: collapse;"><small>{{orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name}}</small></td>
			<td style="width:15%;text-align:center;font-size:13px;border: 1px solid black;border-collapse: collapse;"><small>{{orderItem.menuItemTypesByMenuItemTypeId.price | formatNumber}}</small></td>
			<td style="width:15%;text-align:center;font-size:13px;border: 1px solid black;border-collapse: collapse;"><small>{{orderItem.quantity}}</small></td>
			<td style="width:15%;text-align:center;font-size:13px;border: 1px solid black;border-collapse: collapse;"><small>{{orderItem.totalPrice | formatNumber}}</small></td>
		</tr>
		<template v-for="(itemAddOn, itemAddOnIndex) in orderItem.orderItemAddOnsById">
			<tr v-bind:key="orderItemIndex+'_'+itemAddOnIndex">
				<td></td>
				<td style="width:50%;text-align:left;font-size:13px;border: 1px solid black;border-collapse: collapse;"> <small>&nbsp &nbsp *{{itemAddOn.addOnItemsByAddOnItemId.name}}</small></td>
				<td style="width:15%;text-align:center;font-size:13px;border: 1px solid black;border-collapse: collapse;"><small>{{itemAddOn.addOnItemsByAddOnItemId.price | formatNumber}}</small></td>
				<td style="width:15%;text-align:center;font-size:13px;border: 1px solid black;border-collapse: collapse;"><small>{{itemAddOn.quantity}}</small></td>
				<td style="width:15%;text-align:center;font-size:13px;border: 1px solid black;border-collapse: collapse;"><small>{{itemAddOn.quantity * itemAddOn.addOnItemsByAddOnItemId.price | formatNumber}}</small></td>
			</tr>
		</template>
	</template>
	</table>
	<center>Payment Method: {{(this.selectedTableOrder.paymentMethod.id===1) ? "CASH" : "CARD"}}</center>
	<table style="width:100%">
		<tr>
			<td style="width:70%; text-align:right;font-size:13px;"> Sub Total:</td>
			<td style="width:10%;"></td>
			<td style="width:20%; text-align:left;font-size:13px;">Rs.{{formatPrice(parseFloat(this.selectedTableOrder.totalPriceWithAddon).toFixed(2))}}</td>
		</tr>

		<tr>
			<td style="width:70%; text-align:right;font-size:13px;">GST@{{(this.selectedTableOrder.paymentMethod.id===1)? this.selectedTableOrder.branchesByBranchId.tax: this.selectedTableOrder.branchesByBranchId.cardTax}}%:</td>
			<td style="width:10%;"></td>
			<td style="width:20%; text-align:left;font-size:13px;">Rs.{{formatPrice(parseFloat(this.selectedTableOrder.totalPriceAfterTax - this.selectedTableOrder.totalPriceWithAddon).toFixed(2))}}</td>
		</tr>
		<tr>
			<td style="width:70%; text-align:right;font-size:13px;">Discount:</td>
			<td style="width:10%;"></td>
			<td style="width:20%; text-align:left;font-size:13px;">Rs.{{formatPrice(parseFloat(this.selectedTableOrder.discount).toFixed(2))}}</td>
		</tr>
		<tr>
			<td style="width:70%; text-align:right;font-size:13px;">Billed Amt:</td>
			<td style="width:10%;"></td>
			<td style="width:20%; text-align:left;font-size:14px;"><b>Rs.{{formatPrice(this.selectedTableOrder.billedPrice)}}</b></td>
		</tr>
		<tr v-if="this.selectedTableOrder.cashTaken>0">
			<td style="width:70%; text-align:right;font-size:13px;">Paid Amt:</td>
			<td style="width:10%;"></td>
			<td style="width:20%; text-align:left;font-size:13px;">Rs.{{formatPrice(this.selectedTableOrder.cashTaken)}}</td>
		</tr>
		<tr v-if="this.selectedTableOrder.cashGiven>0">
			<td style="width:70%; text-align:right;font-size:13px;">Change Due:</td>
			<td style="width:10%;"></td>
			<td style="width:20%; text-align:left;font-size:13px;">Rs.{{formatPrice(this.selectedTableOrder.cashGiven)}}</td>
		</tr>				
	</table>
	<br><br>
	<center>
		<b>Thank You for visiting {{this.selectedTableOrder.branchesByBranchId.restaurantsByRestaurantId.name}}</b>
		<p style="font-size:10px;">
			To Place Your Order or To Give FeedBack, Call Us At {{this.selectedTableOrder.branchesByBranchId.phone1}}
			or Visit Our Restaurant
		</p>
	</center>

  </div>
  </section>
</template>

<script>
import numeral from 'numeral';
export default {
    name:"posReceipt",
	props:['selectedTable', 'selectedTableOrder','orderCreatedtime'],
	data(){
		return{

		}
	},
	methods: {
		formatPrice(value) {
			if(value !== null){
				return numeral(value).format('0,0[.]00'); //[00] to format to two decimal number
			}
		},
	}

}
</script>

<style scoped>
.center {
  margin-left: auto;
  margin-right: auto;
}
</style>